<template>
	<div class="birthday">
		<div class="form_tx">תאריך יום הולדת</div>

		<div class="birthday-row">
			<div class="form_input birthday-day">
				<input
					type="number"
					v-model="birthday.day"
					v-validate="{
						regex: /^(0?[1-9]|[12][0-9]|3[01])$/,
					}"
					name="birthday_day"
					data-validation="birthday_day"
					placeholder="יום"
					@input="inputChanged($event, 'birthday_day')"
				/>
				<div class="error_tx" v-if="errors.first('birthday_day')">
					{{ errors.first("birthday_day") }}
				</div>
			</div>
			<div class="form_input birthday-month">
				<input
					type="number"
					v-model="birthday.month"
					v-validate="{
						regex: /^(0?[1-9]|1[0-2])$/,
					}"
					name="birthday_month"
					data-validation="birthday_month"
					placeholder="חודש"
					@input="inputChanged($event, 'birthday_month')"
					ref="birthdayMonth"
				/>
				<div class="error_tx" v-if="errors.first('birthday_month')">
					{{ errors.first("birthday_month") }}
				</div>
			</div>
			<div class="form_input birthday-year">
				<input
					type="number"
					v-model="birthday.year"
					v-validate="{
						regex: /^[1-2][0-9]{3}$/,
					}"
					name="birthday_year"
					data-validation="birthday_year"
					placeholder="שנה"
					@input="inputChanged($event, 'birthday_year')"
					ref="birthdayYear"
				/>
				<div class="error_tx" v-if="errors.first('birthday_year')">
					{{ errors.first("birthday_year") }}
				</div>
			</div>
		</div>
		<input type="hidden" name="birthday" :value="birthday.date" />
		<div class="subtitle">עדכנו אותנו בתאריך יום ההולדת שלכם ואנחנו נפנק אותכם במתנת יום הולדת מאיתנו :)</div>
	</div>
</template>

<script>
	import moment from "moment";

	export default {
		data() {
			return {
				birthday: {
          date: this.$store.getters.formFields("birthday") ? this.$store.getters.formFields("birthday") : '',
					day: this.$store.getters.formFields("birthday_day") ? this.$store.getters.formFields("birthday_day") : '',
					month: this.$store.getters.formFields("birthday_month") ? this.$store.getters.formFields("birthday_month") : '',
					year: this.$store.getters.formFields("birthday_year") ? this.$store.getters.formFields("birthday_year") : '',
				},
			};
		},
		mounted() {
			console.log('birthday', this.birthday.date);
			if (this.birthday.date) {
				const date = moment(this.birthday.date);
				this.birthday.day = date.date();
				this.birthday.month = date.month() + 1;
				this.birthday.year = date.year();
			}
		},
		methods: {
			inputChanged(e, name) {
				let value = typeof e === "object" ? e.target.value : e;
				this.$store.commit("setFormFields", { name: name, value: value });

				let formFields = localStorage.getItem("formFields");
				formFields = formFields === null ? {} : JSON.parse(formFields);
				formFields[name] = value;
				localStorage.setItem("formFields", JSON.stringify(formFields));

				if (name === "birthday_day" && value.length === 2 ) {
					this.$validator.validate('birthday_day').then(valid => {
						if (valid && (/^(0?[1-9]|[12][0-9]|3[01])$/).test(value)) {
							this.$refs.birthdayMonth.focus();
						}
					})
				}
				if (name === "birthday_month" && value.length === 2) {
					this.$validator.validate('birthday_month').then(valid => {
						if (valid && (/^(0?[1-9]|1[0-2])$/).test(value)) {
							this.$refs.birthdayYear.focus();
						}
					})
				}
			},
			calculateBirthdayDate() {
				if (this.birthday.day && this.birthday.month && this.birthday.year) {
					const date = moment([this.birthday.year, this.birthday.month - 1, this.birthday.day]).toDate();

					if (moment(date).isValid()) {
						this.birthday.date = moment(date).format("YYYYMMDD");

						this.$store.commit("setFormFields", {
							name: "birthday",
							value: this.birthday.date,
						});

						let formFields = localStorage.getItem("formFields");
						formFields = formFields === null ? {} : JSON.parse(formFields);
						formFields["birthday"] = this.birthday.date;
						localStorage.setItem("formFields", JSON.stringify(formFields));
					}
				}
			},
		},
		watch: {
			"birthday.day": function (newVal) {
        if (newVal) {
          this.calculateBirthdayDate();
        }
			},
			"birthday.month": function (newVal) {
        if (newVal) {
          this.calculateBirthdayDate();
        }
			},
			"birthday.year": function (newVal) {
        if (newVal) {
          this.calculateBirthdayDate();
        }
			},
    },
		computed: {},
		components: {},
	};
</script>

<style lang="scss" scoped>
	.birthday-row {
		display: flex;
		gap: 15px;
		//flex-direction: row-reverse;

		.form_input {
			flex: 0 1 25%;

			&.birthday-year {
				flex: 1;
			}
		}
	}

	.subtitle {
		font-size: 13px;
	}
</style>